import { render } from "./WizardPlantTypeSelection.vue?vue&type=template&id=1dfca87f&ts=true"
import script from "./WizardPlantTypeSelection.ts?vue&type=script&lang=ts"
export * from "./WizardPlantTypeSelection.ts?vue&type=script&lang=ts"

import "./WizardPlantTypeSelection.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__